import React from 'react';
// import { FormikConsumer } from 'formik';
import FormikContext from '../forms/FormikContext';

export default function useFormik() {
  return React.useContext(FormikContext);
}
